import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaAngleUp,
  FaAngleDown,
} from "react-icons/fa";
import ItodoImage from "../../elements/itodo-img";

const MobileNav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [openSubDropdown, setOpenSubDropdown] = useState(null);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
    setOpenDropdown(null);
    setOpenSubDropdown(null);
  }, [location.pathname]);

  const toggleDropdown = (key) => {
    setOpenDropdown((prev) => (prev === key ? null : key));
    setOpenSubDropdown(null);
  };

  const toggleSubDropdown = (key) => {
    setOpenSubDropdown((prev) => (prev === key ? null : key));
  };

  const renderIcon = (isOpen) =>
    isOpen ? <FaAngleUp className="text-white float-end" /> : <FaAngleDown className="text-white float-end" />;

  return (
    <>
      <div className="header-mobile
       bg-dark d-flex justify-content-between align-items-center px-3 py-2">
        <div className="mobile-logo">
          <NavLink to="/">
            <img src="/assets/images/Logo-1 (2).png" alt="Logo" />
          </NavLink>
        </div>

        <div className=" text-custom fs-3" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>

      <div className={`mobile-menu bg-dark ${menuOpen ? "open" : ""}`}>
        <ul className="menu-list list-unstyled px-3">
          <li><NavLink className="text-white d-block py-2" to="/">Home</NavLink></li>

          {/* About Us */}
          <li>
            <div onClick={() => toggleDropdown("about")} className="toggle-row d-flex justify-content-between align-items-center text-white py-2">
              <NavLink className="text-white" to="/about-us">About Us</NavLink>
              {renderIcon(openDropdown === "about")}
            </div>
            <ul className={`sub-menu list-unstyled ps-3 ${openDropdown === "about" ? "show" : "d-none"}`}>
              <li><NavLink className="text-white d-block py-1" to="/faq">Faq Page</NavLink></li>
              <li><NavLink className="text-white d-block py-1" to="/gallery">Gallery</NavLink></li>
              <li><NavLink className="text-white d-block py-1" to="/testimonials">Testimonials</NavLink></li>
            </ul>
          </li>

          {/* Services */}
          <li>
            <div onClick={() => toggleDropdown("services")} className="toggle-row d-flex justify-content-between align-items-center text-white py-2">
              <NavLink className="text-white" to="/services">Services</NavLink>
              {renderIcon(openDropdown === "services")}
            </div>

            <ul className={`sub-menu list-unstyled ps-3 ${openDropdown === "services" ? "show" : "d-none"}`}>

              {/* Subcategory Template */}
              {[
                {
                  key: "custom",
                  label: "Custom Software Solutions",
                  to: "/service/custom-software/#custom-software-development",
                  links: [
                    "Custom Software Development",
                    "Business Process Automation",
                    "Automating Business Processes through Mobile Apps",
                    "Microsoft Dynamics 365 CRM"
                  ],
                  path: "/service/custom-software"
                },
                {
                  key: "mobile",
                  label: "Mobile App Development",
                  to: "/service/custom-software/#custom-software-development",
                  links: [
                    "Native Mobile Apps",
                    "Android App Development",
                    "Cross-Platform & Hybrid Apps",
                    "Flutter App Development",
                    "React Native App Development"
                  ],
                  path: "/service/app-development"
                },
                {
                  key: "web",
                  label: "Web Development",
                  to: "/service/custom-software/#custom-software-development",
                  links: [
                    "Custom Website Development",
                    "Business & Corporate Websites",
                    "Custom Web Applications"
                  ],
                  path: "/service/web-development"
                },
                {
                  key: "ecom",
                  label: "E-commerce Solutions",
                  to: "/service/custom-software/#custom-software-development",
                  links: [
                    "E-commerce Website Development",
                    "Shopify Store Development",
                    "WooCommerce Development",
                    "Custom E-commerce Platforms"
                  ],
                  path: "/service/e-commerce-solutions"
                },
                {
                  key: "marketing",
                  label: "Digital Marketing Services",
                  to: "/service/custom-software/#custom-software-development",
                  links: [
                    "SEO & Performance Marketing",
                    "Social Media Marketing & Branding",
                    "Conversion Optimization & Lead Generation"
                  ],
                  path: "/service/digital-marketing"
                },
                {
                  key: "qa",
                  label: "Quality Assurance & Testing",
                  to: "/service/custom-software/#custom-software-development",
                  links: [
                    "Manual & Automated Testing",
                    "Performance & Security Testing",
                    "Mobile & Web App Testing",
                    "Bug Tracking & Fixing"
                  ],
                  path: "/service/quality-testing"
                },
                {
                  key: "transform",
                  label: "Digital Transformation",
                  to: "/service/custom-software/#custom-software-development",
                  links: [
                    "Legacy System Modernization",
                    "Cloud & AI Integration",
                    "Process Optimization & Automation",
                    "Technology Strategy Consulting"
                  ],
                  path: "/service/digital-consulting"
                }
              ].map((section) => (
                <li key={section.key}>
                  <div onClick={() => toggleSubDropdown(section.key)} className="toggle-row d-flex justify-content-between align-items-center text-white py-2">
                    <NavLink className="text-white" to={section.to}>{section.label}</NavLink>
                    {renderIcon(openSubDropdown === section.key)}
                  </div>
                  <ul className={`sub-menu list-unstyled ps-3 ${openSubDropdown === section.key ? "show" : "d-none"}`}>
                    {section.links.map((link, idx) => (
                      <li key={idx}>
                        <NavLink className="text-white d-block py-1" to={section.path}>{link}</NavLink>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </li>

          {/* Portfolio */}
          <li>
            <div  className="toggle-row d-flex justify-content-between align-items-center text-white py-2">
              <NavLink className="text-white" to="/portfolio">Portfolio</NavLink>
              {/* {renderIcon(openDropdown === "portfolio")} */}
            </div>
            {/* <ul className={`sub-menu list-unstyled ps-3 ${openDropdown === "portfolio" ? "show" : "d-none"}`}>
              <li><NavLink className="text-white d-block py-1" to="/mission">Mission & Vision</NavLink></li>
            </ul> */}
          </li>

          <li><NavLink className="text-white d-block py-2" to="/team">Team</NavLink></li>
          <li><NavLink className="text-white d-block py-2" to="/blogs">Blogs</NavLink></li>
          <li><NavLink className="text-white d-block py-2" to="/contact-us">Contact Us</NavLink></li>
        </ul>
      </div>
    </>
  );
};

export default MobileNav;